<template>
  <k-input
    clear-suffix
    clearable-on-hover
    original-readonly
    class="km-date-time-picker-input"
    :value="!labels.isNoValue"
    :input-class="'km-date-time-picker-input__inner'"
    :class="selectCss"
    :disabled="disabled"
    :clearable="clearable"
    :size="size"
    :prefix="hidePickerIcon ? '' : 'clock'"
    @focus="focused = true"
    @blur="focused = false"
    @clear="handleClear"
  >
    <div
      class="km-date-time-picker-input__label"
    >
      <div
        class="km-date-time-picker-input__label-value"
        :class="labels.from.isNoValue?'km-date-time-picker-input__label-no-value':''"
      >
        {{ labels.from.label }}
      </div>
      <div :class="labels.from.isNoValue || labels.to.isNoValue?'km-date-time-picker-input__label-no-value':''">
        {{ rangeSeparator }}
      </div>
      <div
        class="km-date-time-picker-input__label-value"
        :class="labels.to.isNoValue?'km-date-time-picker-input__label-no-value':''"
      >
        {{ labels.to.label }}
      </div>
    </div>
    <template slot="suffix">
      <k-icon
        icon="chevron-down"
        class="km-date-picker__arrow"
      />
    </template>
  </k-input>
</template>
<script>
import { Input } from '../input'
import Icon from '../icon'
import moment from 'moment-mini'

export default {
  name: 'KDateTimePickerInput',
  components: {
    KInput: Input,
    KIcon: Icon,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default: () => [],
    },
    size: {
      validator: (value) =>
        ['large', 'normal', 'small', 'mini'].indexOf(value) !== -1,
      default: 'normal',
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hidePickerIcon: {
      type: Boolean,
      default: false,
    },
    rangeSeparator: {
      type: String,
      default: '-',
    },
    labelFormat: {
      type: String,
      default: 'YYYY-MM-DD HH:mm',
    },
    startPlaceholder: {
      type: String,
      default: '开始日期',
    },
    endPlaceholder: {
      type: String,
      default: '结束日期',
    },
  },
  data() {
    return {
      focused: false,
      labels: {},
    }
  },
  computed: {
    selectCss() {
      return {
        'is-active': this.active || this.focused,
      }
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.formLabels(val)
      },
    },
  },
  methods: {
    handleClear(e) {
        e && e.stopPropagation()
        this.$emit('clear')
    },
    formLabels(val = []) {
      const from = this.formatLabel(val[0], this.startPlaceholder)
      const to = this.formatLabel(val[1], this.endPlaceholder)
      this.labels = {
          from,
          to,
          isNoValue: from.isNoValue && to.isNoValue,
      }
    },
    formatLabel(value, placeholder) {
      const isNoValue = !(value && moment(value).isValid())
      return {
        label: isNoValue ? placeholder : moment(value).format(this.labelFormat),
        isNoValue,
      }
    },
  },
}
</script>
<style lang="scss">
  .km-date-time-picker-input{
    width: 360px;
    &__inner {
        display: flex;
        align-items: center;
    }
    &__label{
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      &-value{
        flex: 1;
        text-align: center;
      }
    }
    &__label-no-value{
      color: #b3b3b4;
    }
  }
</style>
